// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"328": "modern-screenshot","399": "venn-debug","699": "xlsx",}[chunkId] + "." + {"328": "22fe2fa796660dcc","399": "7930ce72e7769338","699": "9d5bf3b6b4c46b73",}[chunkId] + ".js"
}